import * as React from "react";
import DatePicker from "react-datepicker";
import * as Const from "../../Constants";
import { Moment } from "moment";
import moment from "moment";
import { registerLocale } from "react-datepicker"; // Import registerLocale
import { enGB } from "date-fns/locale";

// Register the locale
registerLocale("en-gb", enGB);

const CustomInput = React.forwardRef((props: any, ref: any) => {
    return (
        <div style={{ marginBottom: "4px" }}>
            <input
                style={{
                    background: `url(/calendar.svg) no-repeat right`,
                    border: "1px solid rgba(0, 0, 0, 0.1)",
                    padding: "0.4rem",
                    width: "100%",
                }}
                value={props.value}
                placeholder={props.placeholder}
                onClick={props.onClick}
                onBlur={props.onBlur}
                onChange={props.onChange}
                className={props.className}
                ref={ref}
            />
        </div>
    );
});
interface DatePickerProps {
    onBlur?: (date: moment.Moment | Date) => void;
    onChange?: (date: moment.Moment | Date) => void;
    withPortal?: boolean;
    selected?: string | Moment | Date;
    placeholder?: string;
    fixedHeight?: boolean;
}

export default function IBDatePicker(props: DatePickerProps) {
    // Ensuring 'selected' is converted to a Date object if it's a Moment instance as in v3 Date object is used instead of moment
    const dateToDisplay = moment.isMoment(props.selected)
        ? props.selected.toDate()
        : props.selected;
    return (
        <DatePicker
            dateFormat={"yyyy-MM-dd"} // format changed in new version of react-datepicker
            selected={dateToDisplay}
            onChange={props.onChange}
            placeholderText={props.placeholder}
            locale="en-gb"
            className="form-control"
            withPortal={props.withPortal}
            showYearDropdown={true}
            dropdownMode="select"
            fixedHeight={props.fixedHeight}
            customInput={<CustomInput />}
            strictParsing //to allow only valid dates when entering manually
            minDate={new Date(1920, 0, 1)}
        />
    );
}
